import cn from "classnames";
import { createRequestForUploadFile } from "helpers/form";
import React, { Fragment } from "react";
import { alert } from "services/alert";
import { FormTemplate } from "./templates";

export default class FileUploadModal extends FormTemplate {
    initialState = {
        paramsRequest: { body: null },
        dragHighlight: false,
        previewImages: [],
        files: [],
        loadingIndex: null,
    };

    componentDidMount() {
        this.setState({ isLoading: false, ...this.initialState });
        if (this.props.files) {
            this.setState({ files: this.props.files });
            this.buildRequest(this.props.files);
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { loadingIndex } = this.state;
        if (loadingIndex === null) {
            this.setState({ loadingIndex: 0 });
            return this.sendRequest().then(this.close);
        }
    };

    eventDefault = (e, eventName) => {
        e.preventDefault();
        e.stopPropagation();

        if (eventName === "onDragEnter" || eventName === "onDragOver") {
            return this.setState({ dragHighlight: true });
        }

        if (eventName === "onDragLeave") {
            return this.setState({ dragHighlight: false });
        }

        if (eventName === "onDrop") {
            const files = Array.from(e.dataTransfer.files);
            if (files.length > 5) {
                return alert({ type: "warning", message: "Доступна загрузка не более 5 файлов", title: "Ошибка" });
            }
            this.setState({ files });
            this.buildRequest(files);
        }
    };

    uploadFileByInput = () => {
        const files = Array.from(this.field.files);
        if (files.length > 5) {
            return alert({ type: "warning", message: "Доступна загрузка не более 5 файлов", title: "Ошибка" });
        }
        this.setState({ files });
        this.buildRequest(files);
    };

    buildRequest = (files) => {
        this.setState({ dragHighlight: false });
        this.previewFiles(files);
    };

    deletePhoto = (index) => {
        this.field.value = "";
        const { previewImages, files } = this.state;
        previewImages.splice(index, 1);
        files.splice(index, 1);
        this.setState({ previewImages, files });
    };

    sendRequest = async () => {
        const { propName, uploadFile, action } = this.props;
        const { files } = this.state;

        const uploadedFiles = [];

        await files.reduce((acc, file, index) => {
            return acc.then(async () => {
                const paramsRequest = createRequestForUploadFile(propName, file);

                this.setState({ loadingIndex: index });

                const uploadResponse = await uploadFile(paramsRequest);

                this.setState({ loadingIndex: null });

                uploadedFiles.push(uploadResponse);
            });
        }, Promise.resolve());

        action?.(uploadedFiles);

        return uploadedFiles;
    };

    previewFiles = (files) => {
        const promises = files.map((file) => {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onloadend = () => {
                    return resolve(reader.result);
                };
            });
        });
        Promise.all(promises).then((previewImages) => this.setState({ previewImages }));
    };

    renderActionSend = () => {
        const { files } = this.state;
        const cname = cn("btn btn-brand btn-sm modal-window__footer-action", { "btn--disabled": files.length === 0 });
        return <input type="submit" className={cname} value="Загрузить" disabled={files.length === 0} />;
    };

    renderPreviewImages = () => {
        const { previewImages, files, loadingIndex } = this.state;
        if (!previewImages.length) {
            return null;
        }
        return (
            <div className="file-upload__preview-wrap">
                {files.map((file, i) => {
                    const isImage = file.type.includes("image");
                    const props = {
                        className: cn("file-upload__preview", {
                            loading: loadingIndex !== null && loadingIndex === i,
                            "file-upload__preview--loaded": loadingIndex !== null && i <= loadingIndex,
                        }),
                        style: isImage ? { backgroundImage: `url("${previewImages[i]}")` } : {},
                    };

                    const needLineBreak = i !== files.length - 1 && (files.length === 4 ? i === 1 : (i + 1) % 3 === 0);
                    return (
                        <Fragment key={i}>
                            <div {...props}>
                                <div className="file-upload__preview--name">{file.name}</div>
                                <span onClick={() => this.deletePhoto(i)} className="file-upload__delete-button" />
                                {!isImage && <div className="file-upload__preview--default" />}
                                {loadingIndex !== null && i < loadingIndex && (
                                    <div className="file-upload__preview-loaded" />
                                )}
                            </div>
                            {needLineBreak && <div className="file-upload__break" />}
                        </Fragment>
                    );
                })}
            </div>
        );
    };

    renderBodyInner = () => {
        const { dragHighlight, paramsRequest, previewImages } = this.state;
        const wrapCname = cn({
            "file-upload__area": true,
            "file-upload__area--highlight": dragHighlight,
            "file-upload__area--filled": paramsRequest.body,
        });
        const events = {
            onDragEnter: (e) => this.eventDefault(e, "onDragEnter"),
            onDragOver: (e) => this.eventDefault(e, "onDragOver"),
            onDragLeave: (e) => this.eventDefault(e, "onDragLeave"),
            onDrop: (e) => this.eventDefault(e, "onDrop"),
        };
        return (
            <div className={wrapCname} {...events}>
                <label className="file-upload__input-wrap" title="Выберите файлы">
                    {!previewImages.length && <div className="file-upload__drag-icon" />}
                    <input
                        multiple={this.props.isMultiple}
                        ref={(e) => (this.field = e)}
                        type="file"
                        onChange={this.uploadFileByInput}
                        className="file-upload__input"
                        accept={this.props.accept}
                    />
                </label>
                {this.renderPreviewImages()}
            </div>
        );
    };
}
